var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHired(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#C7FFE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0029 14.667C16.5801 14.667 18.6696 15.8604 18.6699 17.333C18.6699 18.8058 16.5803 20 14.0029 20C11.4256 20 9.33594 18.8058 9.33594 17.333C9.33625 15.8604 11.4258 14.667 14.0029 14.667ZM14.0029 8C15.4757 8 16.6699 9.19423 16.6699 10.667C16.6697 12.1396 15.4756 13.333 14.0029 13.333C12.5303 13.333 11.3361 12.1396 11.3359 10.667C11.3359 9.19423 12.5302 8 14.0029 8Z",
    fill: "#00AC64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHired);
export default __webpack_public_path__ + "static/media/hired.a2c6165013cb332fb3fb95563ce57d5f.svg";
export { ForwardRef as ReactComponent };